import { all, call, fork, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse } from 'axios'
import { OverviewModel, SupportedBlockchainsModel } from '../../constants/DataModels'
import API from 'src/api/api'
import { runSagaTask } from '../loadingTask/LoadingTaskHelper'
import { setDayRelay, setOverviewData, setSupportedBlockchainsData, StatsActionTypes, } from '../stats/StatsActions'
import { RequestOverviewData, RequestSupportedBlockchainData } from '../stats/StatsTypes'
import { getUtcTimestampNHoursAgo } from 'src/constants/ConversionUtils'

//watchers
function* getSupportedBlockchains() {
  yield takeEvery(StatsActionTypes.REQUEST_SUPPORTED_BLOCKCHAINS_DATA, getSupportedBlockchainData)
}

function* getOverview() {
  yield takeEvery(StatsActionTypes.REQUEST_OVERVIEW_DATA, getOverviewData)
}

//workers
function* getSupportedBlockchainData(action: RequestSupportedBlockchainData) {
  yield runSagaTask('runStatsBlockchainSaga', function* () {
    const SupportedBlockchainsData = (yield call(
      getSupportedBlockchainsApi
    )) as AxiosResponse<SupportedBlockchainsModel>
    yield put(setSupportedBlockchainsData(SupportedBlockchainsData.data))
  })
}

function* getOverviewData(action: RequestOverviewData) {
  yield runSagaTask('runStatsOverviewSaga', function* () {
    const OverviewData = (yield call(
      getOverviewDataAPI
    )) as AxiosResponse<OverviewModel>
    yield put(setOverviewData(OverviewData.data))
  })

  yield runSagaTask('runDayTxSaga', function* () {
    // last 24h
    const currentDate = getUtcTimestampNHoursAgo(24)
    const LatestOverviewData = (yield call(
      getDayTxDataAPI,
      currentDate
    )) as AxiosResponse<OverviewModel>
    yield put(setDayRelay(LatestOverviewData.data.relay_count))
  })
}

//API call
async function getSupportedBlockchainsApi() {
  return await API.get<SupportedBlockchainsModel>(`/stats/supported_blockchains`)
}

async function getOverviewDataAPI() {
  return await API.get<OverviewModel>(`/stats/overview`)
}

async function getDayTxDataAPI(date: string) {
  return await API.get<OverviewModel>(`/stats/overview?start_time=${date}`)
}

export function* StatsSaga() {
  yield all([fork(getSupportedBlockchains), fork(getOverview)])
}
